export default __webpack_public_path__ + "static/media/computer2.812127ba.jpg";